import React from 'react'
import { Redirect } from 'react-router-dom'
import { AuthContext } from '../AuthProvider'
import PropTypes from 'prop-types'
import { HOME as ADMIN_HOME } from '../Admin/routes'
import { LOGIN } from '../App/routes'

const AuthRedirect = ({ location: { pathname: path, state } }) => {
  return (
    <AuthContext.Consumer>
      {({ user }) => {
        if (user !== null) {
          if (state) {
            if (state.from) {
              if (['/', LOGIN].includes(state.from))
                return <Redirect to={ADMIN_HOME} />
              else return <Redirect to={state.from} />
            }
          }
          return null
        } else if (path !== LOGIN) return <Redirect to={LOGIN} />
      }}
    </AuthContext.Consumer>
  )
}

AuthRedirect.propTypes = {
  location: PropTypes.object.isRequired
}

export default AuthRedirect



// WEBPACK FOOTER //
// ./src/components/AuthRedirect/index.jsx